import Nanobus from "nanobus";
import { getTableConfig } from "AC/table/utils/global";
import axios from "axios";
import { mapDataToFormData } from "AC/helpers/global";
var ScreenOption = /** @class */ (function () {
    function ScreenOption(element) {
        this.element = element;
        this.state = false;
        this.events = new Nanobus();
        this.init();
    }
    ScreenOption.prototype.init = function () {
        var _this = this;
        this.determineScreenOptionState();
        this.element.addEventListener('click', function () {
            _this.determineScreenOptionState();
            _this.persist();
        });
    };
    ScreenOption.prototype.isEnabled = function () {
        return this.element.checked;
    };
    ScreenOption.prototype.determineScreenOptionState = function () {
        this.isEnabled()
            ? this.enable()
            : this.disable();
    };
    ScreenOption.prototype.enable = function () {
        this.state = true;
        this.events.emit('changeState', true);
    };
    ScreenOption.prototype.disable = function () {
        this.state = false;
        this.events.emit('changeState', false);
    };
    ScreenOption.prototype.persist = function () {
        var tableConfig = getTableConfig();
        void axios.post(ajaxurl, mapDataToFormData({
            action: 'acp_new_inline_show_button',
            value: this.state,
            layout: tableConfig.layout,
            list_screen: tableConfig.list_screen,
            _ajax_nonce: tableConfig.ajax_nonce
        }));
    };
    return ScreenOption;
}());
export default ScreenOption;
